<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="3">
						<el-form-item>
							<span style="font-size: 18px;">制作印章</span>
						</el-form-item>
					</el-col>
					<el-col :span="2" :offset="19" >
						<el-form-item style="text-align: right;">
							<el-button type="warning" @click="back">返回</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="contentBox">
			<div class="formLine">
				<div class="formLable">印章名称：</div>
				<div class="formValue">
					<el-input v-model="signatureName" size="mini" style="width:350px;"></el-input>
				</div>
			</div>
			<div class="formLine">
				<div class="formLable">印章类型：</div>
				<div class="formValue">
					<el-radio-group v-model="signatureType">
						<el-radio v-for="(item,index) in [{value:1,label:'公章'}, {value:2,label:'合同章'}, {value:3,label:'法人章'}, {value:4,label:'财务章'}, {value:5,label:'发票章'}, {value:6,label:'其他用章'}]" :key="index" :label="item.value">{{item.label}}</el-radio>
					</el-radio-group>
				</div>
			</div>
			<div class="formLine">
				<div class="formLable">制作章面：</div>
				<div class="formValue">
					<el-radio-group v-model="mode">
						<el-radio :label="'up'">上传</el-radio>
						<el-radio :label="'make'">自动生成</el-radio>
					</el-radio-group>
				</div>
			</div>
			<div class="formLine" v-if="mode==='up'">
				<div class="formLable"></div>
				<div class="formValue">
					<div class="imgView">
						<div v-for="(item,index) in imageUrl" :key="index" class="imgItem">
							<img alt="" :src="item" v-if="imageUrl.length > 0" >
							<i class="el-icon-error closeBtn" v-if="imageUrl.length > 0" @click="handleDeleteImgClick(index)"></i>
						</div>
						<img style="width: 80px; height: 80px" src="../../../assets/img/uploadImg.png" @click="handleUploadClick" v-if="imageUrl.length===0">
						<input type="file" ref="file" style="width: 0;height: 0;" @change="changeFile"/>
					</div>
				</div>
			</div>
			<div class="formLine" v-if="mode==='make'">
				<div class="formLable">公司名称：</div>
				<div class="formValue">
					<el-input v-model="companyName" size="mini" style="width:350px;"></el-input>
				</div>
			</div>
			<div class="formLine" v-if="mode==='make'">
				<div class="formLable">印章类型：</div>
				<div class="formValue">
					<el-input v-model="companyType" size="mini" style="width:350px;"></el-input>
				</div>
			</div>
			<div class="formLine" v-if="mode==='make'">
				<div class="formLable">信息编码：</div>
				<div class="formValue">
					<el-input v-model="companyNumber" size="mini" style="width:350px;"></el-input>
				</div>
			</div>
			<div class="buttonLine">
				<el-button v-if="mode==='up'" type="warning" size="mini" @click="submit">提交</el-button>
				<el-button v-if="mode==='make'" type="warning" size="mini" @click="clickPreSee">预览</el-button>
			</div>
		</div>
		<el-dialog v-if="preSeeSignature" title="预览印章" width="500px" :visible="preSeeSignature" @close="preSeeSignature=false" :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false">
			<createSeal :msg="msg" @submit="submit_createSeal"></createSeal>
		</el-dialog>
	</div>
</template>
<script>
	import createSeal from "../comp_createSeal.vue"
	export default {
		components:{createSeal},
		data(){
			return{
				//
				signatureName:'',
				signatureType:1,
				mode:'up',
				imageUrl:[],
				companyName:'',
				companyType:'',
				companyNumber:'',
				// 预览
				preSeeSignature:false,
				msg:null,
				
			}
		},
		computed:{
		},
		mounted(){
			
		},
		methods: {
			back(){
				this.$router.back()
			},
			// 上传后提交
			submit(){
				if(this.$public.isNull(this.signatureName)){
					this.$message({
						message: '请输入印章名称',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.imageUrl)){
					this.$message({
						message: '请上传印章图片',
						type: 'error'
					});
					return ;
				}
				let params = {
					"shopId": '',
					"sealName": this.signatureName,
					"sealType": this.signatureType,  // 1公章；2合同章；3法人章；4财务章；5发票章；6其他用章
					"sealUrl": this.imageUrl[0],
				}
				console.log(params)
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_business+'/api/Contract/Seal/Insert', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.signatureName='';
						this.signatureType=1;
						this.imageUrl=[];
						this.companyName='';
						this.companyType='';
						this.companyNumber='';
						return ;
					}
				})
			},
			clickPreSee(){
				this.msg = null;
				if(this.$public.isNull(this.signatureName)){
					this.$message({
						message: '请输入印章名称',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.companyName)){
					this.$message({
						message: '请输入公司名称',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.companyType)){
					this.$message({
						message: '请输入印章类型',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.companyNumber)){
					this.$message({
						message: '请输入信息编码',
						type: 'error'
					});
					return ;
				}
				this.msg = {
					signatureName:this.signatureName,
					signatureType:this.signatureType,
					companyName:this.companyName,
					companyType:this.companyType,
					companyNumber:this.companyNumber,
				}
				this.preSeeSignature = true;
			},
			//转移触发上传按钮
			handleUploadClick(){
				this.$refs.file.click()
			},
			//删除对应图片
			handleDeleteImgClick(index){
				this.imageUrl.splice(index,1)
			},
			//上传
			changeFile(e){
				var index= e.target.files[0].name.lastIndexOf(".");
				var ext = e.target.files[0].name.substr(index+1);
				var formData = new FormData();
				if(ext==='png'||ext==='jpg'||ext==='jpeg'){
					formData.append('img', e.target.files[0])
					this.$upload.uploadImg_dir(formData,{dir:'uploadImg'}).then(data => {
						if (data.timestamp) {
							this.imageUrl.push(data.url);
						}
					})
				}else{
					this.$message({
						message: '只能上传jpg,jpeg,png格式的文件',
						type: 'error'
					});
					return ;
				}
				this.$refs.file.value = null
			},
			// 自作印章
			submit_createSeal(obj){
				if(obj.type==="close"){
					this.preSeeSignature = false;
				}else if(obj.type==='success'){
					this.preSeeSignature = false;
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					this.signatureName='';
					this.signatureType=1;
					this.imageUrl=[];
					this.companyName='';
					this.companyType='';
					this.companyNumber='';
				}
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	padding: 16px 16px 65px 16px;
	height: 100%;
	box-sizing: border-box;
	position: relative;
	.searchBox {
		.el-form-item {
			margin-bottom: 0;
		}
	}
	.contentBox{
		padding-left:30px;padding-top:20px;margin-top:12px;background-color: #fff;
		.formLine{
			display: flex;align-items: center;padding:30px 0 0;
			.formLable{
				font-size: 14px;color: #2A2A2A;width:100px;text-align: right;vertical-align: middle;
			}
			.formValue{
				.imgView{
					flex: 1;
					.imgItem{
						position: relative;
						width: 80px; 
						height: 80px;
						margin-right:20px;
						margin-bottom: 10px;
						float: left;
						img{
							width: 100%;
							height: 100%;
						}
						.closeBtn{
							display: block;
							color: red;
							position: absolute;
							top: -10px;
							right: -10px;
							font-size: 20px;
							z-index: 5;
						}
					}
				}
			}
		}
		.buttonLine{
			padding:50px 0 150px 100px;
		}
	}
}
</style>
